(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["charity-check"] && !Shopify.designMode) return;
  try {
    class CharityCheck extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.update);
    }

    update = () => {
      const questions = [...this.querySelectorAll('.charity-question')];
      const answered = questions.filter((question) => question.querySelector('input:checked')).length;
      const anyNo = Boolean(this.querySelector("input[value='no']:checked"));
      this.dataset.state = anyNo ? 'no' : questions.length && answered === questions.length ? 'yes' : 'pending';
    };
  }

  if (!customElements.get('charity-check')) customElements.define('charity-check', CharityCheck);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tasting-booking"] && !Shopify.designMode) return;
  try {
    /* Booking details for a tasting product. See the doc comment at the top of this block. */
  if (!customElements.get('tasting-booking')) {
    customElements.define(
      'tasting-booking',
      class TastingBooking extends HTMLElement {
        connectedCallback() {
          this.form = document.getElementById(this.dataset.form);
          this.min = Number(this.dataset.min) || 1;
          this.max = Number(this.dataset.max) || 0;
          this.date = this.querySelector('[data-check="date"]');
          this.postcode = this.querySelector('[data-check="postcode"]');
          this.away = this.querySelector('[data-away]');
          this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: this.dataset.currency || 'GBP',
          });

          const earliest = new Date();
          earliest.setDate(earliest.getDate() + (Number(this.dataset.leadDays) || 0));
          this.date.min = earliest.toISOString().slice(0, 10);

          /* "YYYY-MM-DD~Event name|..." from the events collection; see the doc comment. */
          this.blocked = new Map(
            (this.dataset.blocked || '')
              .split('|')
              .filter(Boolean)
              .map((entry) => entry.split('~'))
          );
          this.date.addEventListener('change', () => {
            this.clear(this.date);
            const picked = this.date.value;
            const reason = this.dateProblem();
            if (reason && picked) this.flagDate(reason, []);
            /* A day the calendar has an event on may only be known once the feed answers. */
            if (!reason && picked) {
              this.loadEvents().then(() => {
                const late = this.date.value === picked && this.dateProblem();
                if (late) this.flagDate(late, []);
              });
            }
          });
          const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1200));
          idle(() => this.loadEvents());

          this.querySelectorAll('[data-where]').forEach((radio) => {
            radio.addEventListener('change', () => this.showWhere());
          });
          this.showWhere();

          if (!this.form) return;
          /* On window, in the capture phase: Horizon delegates on:submit from a capture listener on
             document (assets/component.js), which runs before anything on the form itself. */
          this.onSubmit = (event) => {
            if (event.target === this.form) this.check(event);
          };
          window.addEventListener('submit', this.onSubmit, true);
          /* After an add the product form puts the quantity back to its default of one, once the
             cart answers. shopify:cart:lines-update fires as the add starts, so wait it out; the
             submit check still refuses a count under the minimum if anyone is quicker. */
          this.onCart = () => setTimeout(() => this.seedQuantity(), 1500);
          document.addEventListener('shopify:cart:lines-update', this.onCart);
          this.onQuantity = () => this.drawTotal();
          this.form.addEventListener('quantity-selector:update', this.onQuantity);
          this.form.addEventListener('input', this.onQuantity);
          this.form.addEventListener('click', () => requestAnimationFrame(this.onQuantity));
          customElements.whenDefined('quantity-selector-component').then(() => this.seedQuantity());
        }

        disconnectedCallback() {
          window.removeEventListener('submit', this.onSubmit, true);
          document.removeEventListener('shopify:cart:lines-update', this.onCart);
          if (!this.form) return;
          this.form.removeEventListener('quantity-selector:update', this.onQuantity);
          this.form.removeEventListener('input', this.onQuantity);
        }

        get quantity() {
          return this.form ? this.form.querySelector('input[name="quantity"]') : null;
        }

        /* ?guests=N from the tasting cards, held inside the tasting's limits. */
        seedQuantity() {
          const input = this.quantity;
          if (!input) return;
          input.min = String(this.min);
          if (this.max > 0) input.max = String(this.max);
          input.setAttribute('aria-label', this.dataset.quantityLabel);
          const asked = Number(new URLSearchParams(window.location.search).get('guests'));
          let guests = asked || Number(input.value) || this.min;
          if (guests < this.min) guests = this.min;
          if (this.max > 0 && guests > this.max) guests = this.max;
          const selector = input.closest('quantity-selector-component');
          if (selector && typeof selector.setValue === 'function') selector.setValue(String(guests));
          else input.value = String(guests);
          if (selector && typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
          this.drawTotal();
        }

        showWhere() {
          const away = this.querySelector('[data-where="away"]').checked;
          this.away.hidden = !away;
          this.postcode.disabled = !away;
          this.postcode.required = away;
          if (!away) this.clear(this.postcode);
        }

        money(pence) {
          const text = this.currency
            .formatToParts(pence / 100)
            .map((part) => part.value)
            .join('');
          return pence % 100 === 0 ? text.replace(/\.00$/, '') : text;
        }

        drawTotal() {
          const input = this.quantity;
          const line = this.querySelector('[data-total-line]');
          if (!input || !line) return;
          const n = Number(input.value) || 0;
          if (n < 1) {
            line.textContent = '';
            return;
          }
          const price = this.money(Number(this.dataset.price) * n);
          line.textContent = this.dataset.total.replace('[price]', price).replace('[count]', n);
        }

        /* The event days in the calendar, added to `blocked` once. Never rejects: a feed that cannot be
           read refuses nothing, and Jamie confirms every date by hand. */
        loadEvents() {
          if (!this.eventsLoad) {
            this.eventsLoad = import(this.dataset.feed)
              .then((feed) => feed.fetchExperiences(this.dataset.shop, Date.now(), 365).then(feed.eventDays))
              .then((days) => days.forEach((name, day) => this.blocked.has(day) || this.blocked.set(day, name)))
              .catch(() => {})
              .finally(() => {
                this.eventsKnown = true;
              });
          }
          return this.eventsLoad;
        }

        /* Why the chosen date cannot be booked, or '' when it can. */
        dateProblem() {
          const day = this.date.value;
          if (!day || day < this.date.min) return this.dataset.sayEarly;
          if (this.dataset.closedSunday === 'true' && new Date(day + 'T12:00:00').getDay() === 0) {
            return this.dataset.saySunday;
          }
          if (this.blocked.has(day)) {
            /* A bare "en" formats the American way ("Friday, November 13"); this is a UK shop. */
            const lang = document.documentElement.lang;
            const when = new Date(day + 'T12:00:00').toLocaleDateString(!lang || lang === 'en' ? 'en-GB' : lang, {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
            });
            return this.dataset.sayEvent.replace('[date]', when).replace('[name]', this.blocked.get(day));
          }
          return '';
        }

        flagDate(reason, problems) {
          const error = document.getElementById(this.date.id + '-error');
          if (error) error.textContent = reason;
          this.flag(this.date, problems);
        }

        clear(field) {
          field.setAttribute('aria-invalid', 'false');
          const error = document.getElementById(field.id + '-error');
          if (error) error.hidden = true;
        }

        flag(field, problems) {
          field.setAttribute('aria-invalid', 'true');
          const error = document.getElementById(field.id + '-error');
          if (error) {
            error.hidden = false;
            problems.push(error.textContent.trim());
          }
        }

        check(event) {
          /* A submit that beats the feed waits for it, then comes round again through this check. */
          if (!this.eventsKnown && this.date.value) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const submitter = event.submitter;
            this.loadEvents().then(() => {
              try {
                this.form.requestSubmit(submitter);
              } catch {
                this.form.requestSubmit();
              }
            });
            return;
          }
          const problems = [];
          const first = [];
          [this.date, this.postcode].forEach((field) => this.clear(field));

          const reason = this.dateProblem();
          if (reason) {
            this.flagDate(reason, problems);
            first.push(this.date);
          }
          if (this.postcode.required && this.postcode.value.trim().length < 5) {
            this.flag(this.postcode, problems);
            first.push(this.postcode);
          }

          const input = this.quantity;
          const guestsError = this.querySelector('[data-guests-error]');
          const n = input ? Number(input.value) : this.min;
          const guestsBad = n < this.min || (this.max > 0 && n > this.max);
          guestsError.hidden = !guestsBad;
          if (guestsBad) {
            problems.push(guestsError.textContent.trim());
            if (input) first.push(input);
          }
          /* Fewer guests at their place than in the snug (Jamie, 2026-10-01: 8 against 24). */
          const awayError = this.querySelector('[data-away-error]');
          const awayMax = Number(this.dataset.awayMax) || 0;
          const awayBad = !guestsBad && this.postcode.required && awayMax > 0 && n > awayMax;
          awayError.hidden = !awayBad;
          if (awayBad) {
            problems.push(awayError.textContent.trim());
            if (input) first.push(input);
          }

          const summary = this.querySelector('[data-errors]');
          if (!problems.length) {
            summary.hidden = true;
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          summary.replaceChildren();
          const list = document.createElement('ul');
          problems.forEach((text) => {
            const item = document.createElement('li');
            item.textContent = text;
            list.append(item);
          });
          summary.append(list);
          summary.hidden = false;
          (first[0] || summary).focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
